import { Translation } from '@/components/i18n/Translation'

import './no-results.scss'

const NoResults = ({ textId = 'No results' }) => (
  <div className="no-results">
    <Translation id={textId} />
  </div>
)

export default NoResults
